var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRestore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.97723 6C6.39145 6 6.72723 5.66421 6.72723 5.25C6.72723 4.83579 6.39145 4.5 5.97723 4.5C5.56302 4.5 5.22723 4.83579 5.22723 5.25C5.22723 5.66421 5.56302 6 5.97723 6Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97723 12C6.39145 12 6.72723 11.6642 6.72723 11.25C6.72723 10.8358 6.39145 10.5 5.97723 10.5C5.56302 10.5 5.22723 10.8358 5.22723 11.25C5.22723 11.6642 5.56302 12 5.97723 12Z",
    fill: ""
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97723 18C6.39145 18 6.72723 17.6642 6.72723 17.25C6.72723 16.8358 6.39145 16.5 5.97723 16.5C5.56302 16.5 5.22723 16.8358 5.22723 17.25C5.22723 17.6642 5.56302 18 5.97723 18Z",
    fill: ""
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72723 19.5H3.72723V15H9.72723V13.5H3.72723V9H17.2272V3C17.2272 2.60218 17.0692 2.22064 16.7879 1.93934C16.5066 1.65804 16.1251 1.5 15.7272 1.5H3.72723C3.32941 1.5 2.94788 1.65804 2.66657 1.93934C2.38527 2.22064 2.22723 2.60218 2.22723 3V19.5C2.22723 19.8978 2.38527 20.2794 2.66657 20.5607C2.94788 20.842 3.32941 21 3.72723 21H9.72723V19.5ZM3.72723 3H15.7272V7.5H3.72723V3Z",
    fill: ""
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7272 12.75V14.5598C21.2562 13.7722 20.5868 13.1219 19.7858 12.6738C18.9849 12.2258 18.0804 11.9956 17.1628 12.0064C16.2451 12.0171 15.3463 12.2683 14.556 12.735C13.7658 13.2017 13.1118 13.8675 12.6593 14.6659C12.2068 15.4644 11.9716 16.3675 11.9772 17.2852C11.9829 18.203 12.2291 19.1032 12.6914 19.896C13.1537 20.6888 13.8158 21.3465 14.6117 21.8034C15.4077 22.2604 16.3095 22.5005 17.2272 22.5V21C16.5509 21.0009 15.887 20.8188 15.3057 20.4732C14.7245 20.1275 14.2475 19.6311 13.9253 19.0364C13.6031 18.4418 13.4478 17.7711 13.4756 17.0954C13.5035 16.4197 13.7136 15.7641 14.0837 15.198C14.4537 14.632 14.97 14.1765 15.5778 13.8799C16.1855 13.5833 16.8622 13.4566 17.5361 13.5131C18.21 13.5697 18.8561 13.8075 19.4059 14.2013C19.9558 14.595 20.3889 15.1302 20.6594 15.75H18.7272V17.25H23.2272V12.75H21.7272Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRestore);
export default __webpack_public_path__ + "static/media/ic-restore.448b3500de59c46aa4d93588f17a0e26.svg";
export { ForwardRef as ReactComponent };